import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import './index.scss';
import { useState } from "react";
import classNames from "classnames";
import { HomeOutlined, LeftOutlined, MenuOutlined } from '@ant-design/icons';

const Layout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const navClass = classNames('nav', { open });
    const overlayClass = classNames('overlay', { active: open });

    const toggleOpen = () => {
        setOpen(!open);
    };

    const handleNavClick = (item) => {
        if (item.external) {
            window.open(item.path);
        } else {
            navigate(item.path);
        }
        setOpen(false);
    };

    const navItems = [
        { path: '/dashboard', label: '即時戰情面板' },
        { path: 'https://afs-mychatbot.tainan.gov.tw', label: '水廠維運智慧助理', external: true },
    //  { path: 'http://203.145.215.165:8200/', label: '水廠數據智慧查詢', external: true },
        { path: 'https://myagent-platform.twcloud.ai/', label: 'MyAgent智慧助理', external: true },
        { path: '/analyse', label: '污水廠資料模型數據分析' },
        { path: '/alert', label: '警報列表' },
        { path: '/water-flow-simulation', label: 'AI混合模型放流水質預測(水量調控模擬)' },
        { path: '/aeration-simulation', label: 'AI混合模型放流水質預測(曝氣量調控模擬)' },
    ];

    return (
        <div className="site">
            <div className={navClass}>
                <div className="nav-home-wrap">
                    <div
                        className="nav-home-link"
                        onClick={() => window.location.href = '/index.html'}
                        title="回首頁"
                    >
                        <HomeOutlined />
                        <span>回首頁</span>
                    </div>
                </div>
                {navItems.map((item) => (
                    <div className="item" key={item.path}>
                        <div
                            className={classNames('link', {
                                'active': !item.external && location.pathname === item.path
                            })}
                            onClick={() => handleNavClick(item)}
                        >
                            {item.label}
                        </div>
                    </div>
                ))}
            </div>
            <div className={overlayClass} onClick={toggleOpen}></div>
            <div className="main">
                <div className={`toggle ${open ? 'menu-open' : ''}`} onClick={toggleOpen}>
                    <div className="icon-wrapper">
                        <MenuOutlined className={`menu-icon ${open ? 'hide' : 'show'}`} />
                        <LeftOutlined className={`close-icon ${open ? 'show' : 'hide'}`} />
                    </div>
                </div>
                <Outlet />
            </div>
        </div>
    );
};

export default Layout;
